import styles from "./Stack.module.scss";
import html from "../../assets/icons/html.svg";
import css from "../../assets/icons/css.svg";
import js from "../../assets/icons/js.svg";
import python from "../../assets/icons/python.svg";
import mysql from "../../assets/icons/mysql.svg";
import postgre from "../../assets/icons/postgre.svg";
import excel from "../../assets/icons/excel.svg";
import github from "../../assets/icons/github.svg";
import tableau from "../../assets/icons/tableau.svg";
import react from "../../assets/icons/react.svg";

const Stack = () => {
  return (
    <div className={styles.wrapper}>
      <h2>Technical Stack</h2>
      <div className={styles.logos}>
        <figure>
          <img src={html} alt="html" />
          <figcaption>HTML</figcaption>
        </figure>
        <figure>
          <img src={css} alt="css" />
          <figcaption>CSS</figcaption>
        </figure>

        <figure>
          <img src={js} alt="js" />
          <figcaption>Javascript</figcaption>
        </figure>
        <figure>
          <img src={react} alt="react" />
          <figcaption>React</figcaption>
        </figure>
        <figure>
          <img src={python} alt="python" />
          <figcaption>Python</figcaption>
        </figure>
        <figure>
          <img src={mysql} alt="mysql" />
          <figcaption>MySQL</figcaption>
        </figure>
        <figure>
          <img src={tableau} alt="tableau" />
          <figcaption>Tableau</figcaption>
        </figure>
        <figure>
          <img src={postgre} alt="postgre" />
          <figcaption>PostgreSQL</figcaption>
        </figure>
        <figure>
          <img src={excel} alt="excel" />
          <figcaption>Microsoft Excel</figcaption>
        </figure>
        <figure>
          <img src={github} alt="github" />
          <figcaption>Github</figcaption>
        </figure>
      </div>
    </div>
  );
};

export default Stack;
